import styled, { css, keyframes } from 'styled-components';
import { ifProp } from 'styled-tools';
import { Link as LinkOriginal } from 'react-router-dom';
import { fontTitle, fontBody } from 'Styles/fonts';

import ProductVariantOriginal from '../../../ProductVariant/ProductVariant';
import InformationCardOriginal from '../../../InformationCard/InformationCard';
import { Button as StyledButton } from '../../../Button/Button.styled';

const pulseAnimation = keyframes`
  0%, 100% {
    background-color: var(--hover);
  }
  45% {
    background-color: var(--border);
  }
`;

export const InformationCard = styled(InformationCardOriginal)`
  background-color: var(--background);
  margin-bottom: 8px;
`;

export const OrderPreviewHeader = styled.div``;

export const OrderNumberWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
`;

export const OrderNumber = styled.p`
  ${fontTitle(20)};

  ${ifProp(
    'isLoading',
    () => css`
      border-radius: 4px;
      animation: ${pulseAnimation} 3s ease-out infinite normal;
      height: 21px;
      width: 144px;
    `
  )}
`;

export const Date = styled.p`
  ${fontBody(14)};
  color: var(--ring);
  margin-bottom: 12px;

  ${ifProp(
    'isLoading',
    () => css`
      border-radius: 4px;
      animation: ${pulseAnimation} 3s ease-out infinite normal;
      height: 21px;
      width: 144px;
    `
  )}
`;

export const Identifiers = styled.div`
  display: grid;
  grid-template-columns: auto auto auto 1fr;
  grid-column-gap: 48px;
  margin-bottom: 12px;

  ${ifProp(
    'isLoading',
    () => css`
      border-radius: 4px;
      animation: ${pulseAnimation} 3s ease-out infinite normal;
      height: 40px;
      width: 100%;
    `
  )}
`;

export const Identifier = styled.p`
  display: flex;
  flex-direction: column;
  ${fontTitle(14)};

  span {
    ${fontBody(14)};
  }

  &:last-of-type {
    margin-right: -48px;
  }
`;

export const OrderPreview = styled.div``;

export const ProductVariant = styled(ProductVariantOriginal)`
  margin-bottom: 16px;

  /* I dont like this approach since it is heavily coupled to ProductVariant styling */
  &:last-of-type {
    margin-bottom: 0;
    border-bottom: 0;
    padding-bottom: 0;
  }
`;

export const Fulfillment = styled.div`
  margin-bottom: 12px;

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const FulfillmentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  ${fontTitle(18)};
`;

export const FulfillmentDisclaimer = styled.p`
  margin-top: 12px;
  font-style: italic;
  ${fontBody(14)}
`;

export const Button = styled(StyledButton)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TrackButton = styled(Button)`
  margin-bottom: 8px;
`;

export const Link = styled(LinkOriginal)`
  text-decoration: none;
`;

export const LoadingView = styled.div`
  border-radius: 4px;
  animation: ${pulseAnimation} 3s ease-out infinite normal;
  height: 40px;
  width: 100%;
`;

export const LoadingPill = styled.div`
  border-radius: 32px;
  animation: ${pulseAnimation} 3s ease-out infinite normal;
  height: 32px;
  width: 88px;
`;
